<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M11.1702 2.50144C6.92856 2.38478 3.45356 5.79311 3.45356 10.0014H1.96189C1.58689 10.0014 1.40356 10.4514 1.67022 10.7098L3.99522 13.0431C4.16189 13.2098 4.42022 13.2098 4.58689 13.0431L6.91189 10.7098C7.17022 10.4514 6.98689 10.0014 6.61189 10.0014H5.12022C5.12022 6.75144 7.77022 4.12644 11.0369 4.16811C14.1369 4.20978 16.7452 6.81811 16.7869 9.91811C16.8286 13.1764 14.2036 15.8348 10.9536 15.8348C9.61189 15.8348 8.37022 15.3764 7.38689 14.6014C7.05356 14.3431 6.58689 14.3681 6.28689 14.6681C5.93689 15.0181 5.96189 15.6098 6.35356 15.9098C7.62022 16.9098 9.21189 17.5014 10.9536 17.5014C15.1619 17.5014 18.5702 14.0264 18.4536 9.78478C18.3452 5.87644 15.0786 2.60978 11.1702 2.50144ZM10.7452 6.66811C10.4036 6.66811 10.1202 6.95144 10.1202 7.29311V10.3598C10.1202 10.6514 10.2786 10.9264 10.5286 11.0764L13.1286 12.6181C13.4286 12.7931 13.8119 12.6931 13.9869 12.4014C14.1619 12.1014 14.0619 11.7181 13.7702 11.5431L11.3702 10.1181V7.28478C11.3702 6.95144 11.0869 6.66811 10.7452 6.66811Z"
      fill="url(#paint0_linear_181_18700)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_181_18700"
        x1="1.54395"
        y1="2.49854"
        x2="16.5027"
        y2="19.2465"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
    </defs>
  </svg>
</template>
